import React, {Component, Fragment} from "react";
const axios = require('axios');

import {OPEN_PRODUCT} from "../util/events";
import CloseIcon from "../icons/CloseIcon";
import addToCart from "../../components/addToCart";

class ProductPopup extends Component
{

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            product: null,
            adding: false
        }

        this.openProduct = this.openProduct.bind(this);
        this.closeWindow = this.closeWindow.bind(this);
    }

    loadProductData(id)
    {
        this.setState({
            loading: true
        })
        axios.get('cart-api/retrieve-product?pid=' + id).then((response) => {
            const data = response.data;
            if (data.error === 1) {
                this.setState({
                    loading: false,
                    product: null
                });
            } else {
                this.setState({
                    loading: false,
                    product: data
                })
            }
        })
    }

    componentDidMount() {
        this.bindEvents();
    }

    openProduct(e) {
        e.preventDefault();
        if (e.data && e.data.id) {
            this.loadProductData(e.data.id);
        }
    }

    closeWindow(e)
    {
        e.preventDefault();
        this.setState({
            loading: false,
            product: null
        })
        return false;
    }


    bindEvents()
    {
        const body = document.querySelector('body');
        body.addEventListener(OPEN_PRODUCT, this.openProduct)

    }

    render() {
        if (!this.state.loading && !this.state.product) {
            return '';
        }

        return <div className="product-popup">
            <div className="product-popup__inner">
                <div className="container">
                    <div className="container--">
                        <div className="product-popup__close"
                            onClick={this.closeWindow}>
                            <CloseIcon />
                        </div>
                        <div className="product-popup__content">
                            <div className="product-popup__body">

                                {!!this.state.loading && <p>Loading</p>}

                                {!!this.state.product && <Fragment>
                                    <div className="product-popup__image">
                                        {!!this.state.product.image && <img src={this.state.product.image} alt={this.state.product.title} />}
                                    </div>
                                    <div className="product-popup__text">
                                        <h3>{this.state.product.title}</h3>
                                        <p className="product-popup__sku">SKU: {this.state.product.sku}</p>
                                        {this.state.product.price_applied !== '$0.00' && <p className="product-popup__price">
                                            {!!this.state.product.previous_price && <span className="product-popup__price--crossed">{this.state.product.previous_price}</span> }
                                            <span>{this.state.product.price_applied}</span> GST Included
                                        </p>}
                                        {!!this.state.product.summary &&
                                            <p className="product-popup__summary"
                                               dangerouslySetInnerHTML={{__html: this.state.product.summary}}
                                                ></p>
                                        }
                                        <div className="product-popup__action">
                                            <a href={this.state.product.link} className="btn btn--blue btn--blue--solid">
                                                View Product
                                            </a>
                                            {!!this.state.product.can_buy && <a href={'#'}
                                                className="btn btn--blue btn--blue--solid"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.setState({
                                                        adding: true
                                                    })
                                                    addToCart(this.state.product.id, () => {
                                                        this.setState({
                                                            adding: false
                                                        })
                                                    });
                                                    return false;
                                                }}
                                            >
                                                {this.state.adding ? 'Please wait' : 'Add to cart'}
                                            </a>}
                                            {!!this.state.product.out_of_stock && <span className={'text-iconRed font-headings uppercase font-bold'}>Out of stock</span>}
                                        </div>
                                    </div>
                                </Fragment>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="product-popup__bg" />
        </div>
    }

}

export default ProductPopup;
